import { Component } from "react";
import Loader from "../../../../../utils/Loader";
import { ToastContainer } from "react-toastify";
import ExhibitorTopMenu from "../../../../../common_components/exhibitor_module_topmenu";
import { withRouter } from "../../../../../utils/withRouter";
import { connect } from "react-redux";
import { getMeetinRoomMasterList_action, insertUpdateMeetinRoomMaster_action, deleteMeetinRoomMaster_action, verifyMeetingRoomComboSlot_action } from '../../../../../actions/admin_module_action/master_action/manual_form_master_action/meeting_room_master_action'
import { fill_action } from '../../../../../actions/fillCombo_action'
import { BASE_URL, countryActionId, toastError, toastSuccess, visaIdTypeActionId, isOtherAreaActionId } from "../../../../../utils/constants";
import { TimePicker } from '@hilla/react-components/TimePicker.js';
import { emailValidator, mobileNoValidator } from "../../../../../utils/Validator";
import moment from "moment";
import ExhibitorDrawer from "../../../../../common_components/exhibitor_module_drawer";
import ExhibitorHeader from "../../../../../common_components/exhibitor_module_header";
import { data } from "jquery";
import Resizer from "react-image-file-resizer";
import Modal from "react-modal";
import DatePicker from "react-datepicker";
import HeaderWithLogo from "../../../../../common_components/header_with_logo";
import AdminDrawer from "../../../../../common_components/admin_module_drawer";
import Passport_Front_1008_VIS_903747 from "../../../../../files/Passport_Front_1008_VIS_903747.jpeg"

class MeetingRoomMasterAU extends Component {

    // initialize constructor
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            // fields
            Date: null,
            SeatingCapacity: '',
            FromTime: '',
            ToTime: '',
            Location: '',
            PriceName: '',
            RateInINR: '',
            RateInUSD: '',
            // List
            comboSlotList: [{
                MeetingRoomComboSlotID: null,
                ComboSlotHours: '',
                RateInINR: '',
                RateInUSD: ''
            }],
            DateErr: '',
            SeatingCapacityErr: '',
            FromTimeErr: '',
            ToTimeErr: '',
            LocationErr: '',
            PriceNameErr: '',
            RateInINRErr: '',
            index: 1,
            RateInUSDErr: '',
            RoomTypeID: '',
            dupliComboSlotList: [],
            RoomTypeList: [],
            RoomTypeIDErr: '',
            IsComboSlotAvailable: true,
            IsUpdate: false,
            IsComboSlotAvailable: false,
        }
        this.OnCancel = this.OnCancel.bind(this)
        this.inputValidate = this.inputValidate.bind(this)
        this.handleSave = this.handleSave.bind(this)
        this.ClearValue = this.ClearValue.bind(this)
    }

    componentDidMount() {
        this.getFillList(isOtherAreaActionId, '', '', '', '', '');
        this.setState({
            MstMeetingRoomID: this.props.location?.state?.MstMeetingRoomID || null,
            IsUpdate: this.props.location?.state?.IsUpdate || false,
            IsComboSlotAvailable: this.props.location?.state?.IsComboSlotAvailable || false,
        }, () => this.props.location?.state?.MstMeetingRoomID && this.getMeetingRoomMasterMasterList())
    }

    getFillList(actionID, exhibitionID, moduleID, keyValue, value, from) {
        const { } = this.state
        this.setState({ isLoading: true })
        this.props
            .fill_action(actionID, exhibitionID, moduleID, keyValue, value)
            .then((data) => {
                if (data.error != 1) {
                    // country list
                    if (actionID === isOtherAreaActionId) {
                        this.setState({
                            RoomTypeList: data.data
                        })
                    }
                }
                this.setState({ isLoading: false })
            })
            .catch((e) => {
                console.log(e);
            });
    }

    // On cancel Click
    OnCancel() {
        this.props.navigate('/meetingRoomMasterList')
    }
    getMeetingRoomMasterMasterList(status) {
        const { IsUpdate, IsComboSlotAvailable } = this.state
        this.setState({ isLoading: true })
        this.props.getMeetinRoomMasterList_action(this.props.location?.state?.MstMeetingRoomID)
            .then((data) => {
                if (data.error != 1) {
                    this.setState({
                        Date: data.data[0]['Date'] ? moment.utc(data.data[0]['Date'], "YYYY-MM-DD").toDate() : null,
                        RoomTypeID: data.data[0]['RoomTypeID'],
                        SeatingCapacity: data.data[0]['SeatingCapacity'],
                        FromTime: data.data[0]['FromTime'] ? moment.utc(data.data[0]['FromTime']).format('HH:mm') : null,
                        ToTime: data.data[0]['ToTime'] ? moment.utc(data.data[0]['ToTime']).format('HH:mm') : null,
                        Location: data.data[0]['Location'],
                        RateInINR: data.data[0]['RateInINR'],
                        RateInUSD: data.data[0]['RateInUSD'],
                        comboSlotList: IsUpdate == 1 ? (data.comboSlotList || []) : [],
                        dupliComboSlotList: IsUpdate == 1 ? (data.comboSlotList || []) : [],
                    }, () => !IsComboSlotAvailable && this.verifyMeetingRoomComboSlot())
                } else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((err) => {
                console.log(err)
            })
    }

    verifyMeetingRoomComboSlot() {
        const { SeatingCapacity, Date, RoomTypeID, Location } = this.state
        this.props.verifyMeetingRoomComboSlot_action(SeatingCapacity, moment(Date).format('YYYY-MM-DD') || null, RoomTypeID, Location)
            .then((data) => {
                if (data.error != 1) {
                    this.setState({
                        IsComboSlotAvailable: (this.state.MstMeetingRoomID != data.data?.[0]?.MstMeetingRoomID ? data.data?.[0]?.IsComboSlotAvailable : false) || false,
                        isLoading: false,
                        comboSlotList: this.state.MstMeetingRoomID != data.data?.[0]?.MstMeetingRoomID ? [{
                            MeetingRoomComboSlotID: null,
                            ComboSlotHours: '',
                            RateInINR: '',
                            RateInUSD: ''
                        }] : this.state.dupliComboSlotList
                    })
                } else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((err) => {
                console.log(err)
            })
    }

    // Input Fields Validation
    inputValidate() {
        const { Date, SeatingCapacity, FromTime, ToTime, Location, PriceName, RateInINR, RateInUSD, comboSlotList, DateErr, SeatingCapacityErr, FromTimeErr, ToTimeErr, LocationErr, PriceNameErr, RateInINRErr, RateInUSDErr, RoomTypeID } = this.state

        var err = false
        if (Date == "") {
            this.setState({ DateErr: "Please Select Date" })
            err = true
        }
        if (RoomTypeID == "") {
            this.setState({ RoomTypeIDErr: "Please Select Room Type" })
            err = true
        }
        if (FromTime == "") {
            this.setState({ FromTimeErr: "Please Select From Time" })
            err = true
        }
        if (ToTime == "") {
            this.setState({ ToTimeErr: "Please Select To Time" })
            err = true
        }
        if (SeatingCapacity.trim() == "") {
            this.setState({ SeatingCapacityErr: "Please Enter Seating Capacity" })
            err = true
        }
        if (Location.trim() == "") {
            this.setState({ LocationErr: "Please Enter Location" })
            err = true
        }
        if (String(RateInINR).trim() == "") {
            this.setState({ RateInINRErr: "Please Enter Price In INR" })
            err = true
        }
        if (String(RateInUSD).trim() == "") {
            this.setState({ RateInUSDErr: "Please Enter Price In USD" })
            err = true
        }

    }

    handleSave() {
        const { MstMeetingRoomID, Date, SeatingCapacity, FromTime, ToTime, Location, PriceName, RateInINR, RateInUSD, comboSlotList, DateErr, SeatingCapacityErr, FromTimeErr, ToTimeErr, index, LocationErr, PriceNameErr, RateInINRErr, RateInUSDErr, RoomTypeID, IsUpdate } = this.state
        this.inputValidate()
        if (Date != '' && SeatingCapacity != '' && FromTime != '' && ToTime != '' && Location != '' && RateInINR != '' && RateInUSD != '' && RoomTypeID != '') {
            this.setState({ isLoading: true })
            this.props.insertUpdateMeetinRoomMaster_action(IsUpdate == 1 ? MstMeetingRoomID : null, moment(Date).format('YYYY-MM-DD'), RoomTypeID, SeatingCapacity, FromTime, ToTime, Location, RateInINR, RateInUSD, comboSlotList)
                .then((data) => {
                    if (data.error != 1) {
                        toastSuccess("Record Added Successfully")
                        this.setState({ isLoading: false })
                        setTimeout(() => {
                            this.props.navigate('/meetingRoomMasterList')
                        }, 2000);
                    }
                    else {
                        this.setState({ isLoading: false })
                        toastError(data.msg)
                    }
                })
                .catch((err) => {
                    console.log(err)
                })

        }
        else {
            toastError('Please enter mandatory fields')
        }
    }

    ClearValue() {
        this.setState({
            Date: '',
            SeatingCapacity: '',
            FromTime: '',
            ToTime: '',
            Location: '',
            PriceName: '',
            RateInINR: '',
            RateInUSD: '',
            index: this.state.index + 1
        })
    }

    handleComboSlotChange = (index, field, value) => {
        this.setState(prevState => ({
            comboSlotList: prevState.comboSlotList.map((item, i) =>
                i === index
                    ? {
                        ...item,
                        [field]: value
                    }
                    : item
            )
        }));
    };

    handleDeleteComboSlot = (index) => {
        this.setState(prevState => ({
            comboSlotList: prevState.comboSlotList.filter(
                (_, i) => i !== index
            )
        }));
    };

    handleAddComboSlot = () => {
        this.setState(prevState => ({
            comboSlotList: [
                ...prevState.comboSlotList,
                {
                    MeetingRoomComboSlotID: null,
                    ComboSlotHours: '',
                    RateInINR: '',
                    RateInUSD: ''
                }
            ]
        }));
    };

    render() {
        const {
            isLoading, Date, SeatingCapacity, FromTime, ToTime, Location, PriceName, RateInINR, RateInUSD, comboSlotList, DateErr, SeatingCapacityErr, index, FromTimeErr, ToTimeErr, LocationErr, PriceNameErr, RateInINRErr, RateInUSDErr, RoomTypeID, RoomTypeList, RoomTypeIDErr, MstMeetingRoomID, IsComboSlotAvailable, IsUpdate
        } = this.state
        console.log("IsUpdate--->", IsUpdate)
        return (
            <>
                {
                    isLoading ? (
                        <Loader></Loader >
                    ) : (
                        null
                    )
                }
                <ToastContainer />
                <HeaderWithLogo />
                <>
                    <div className="app-content with-dr-container com-height">
                        <AdminDrawer />
                        <div className="main-container">
                            <div className="row m-0">
                                <div className="breadcrumb-scroll-fixed">
                                    <p className="mb-0 p-2 text-white">{MstMeetingRoomID && IsUpdate == 1 ? "Update" : "Add"} Meeting Room</p>
                                </div>
                            </div>
                            <div className="admin-top-space p-2 pt-0">
                                <div className="card-body p-2">
                                    <div className="row">
                                        <div className="col-xl-3">
                                            <label htmlFor="validationCustom03">
                                                Date<span className="text-red">*</span>
                                            </label>
                                            <DatePicker
                                                style={{ zIndex: '99999' }}
                                                selected={Date}
                                                dateFormat={"dd/MM/yyyy"}
                                                className="form-control"
                                                onChange={(date) => this.setState({ Date: date, DateErr: "" }, () => {
                                                    this.verifyMeetingRoomComboSlot();
                                                })}
                                                peekNextMonth
                                                showMonthDropdown
                                                showYearDropdown
                                                dropdownMode="select"
                                                placeholderText="DD/MM/YYYY"
                                            />
                                            {<span className='text-danger text-start text-left d-block mt-1'>{DateErr}</span>}
                                        </div>
                                        <div className="col-md-3">
                                            <label>Room Type <span className="text-red">*</span></label>
                                            <select className="form-control"
                                                value={RoomTypeID}
                                                onChange={(e) => this.setState({ RoomTypeID: e.target.value, RoomTypeIDErr: '' })}
                                                onBlur={(e) => this.verifyMeetingRoomComboSlot()}
                                            >
                                                <option value={''}>Select</option>
                                                {
                                                    RoomTypeList.length > 0 && RoomTypeList.map(data => (
                                                        <option value={data.ExhibitionOtherAreaID} key={data.ExhibitionOtherAreaID}>{data.Name}</option>
                                                    ))
                                                }
                                            </select>
                                            {<span className='text-danger text-start text-left d-block mt-1'>{RoomTypeIDErr}</span>}
                                        </div>
                                        <div className="col-xl-3">
                                            <label htmlFor="validationCustom03">
                                                Seating Capacity<span className="text-red">*</span>
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="validationCustom03"
                                                required=""
                                                value={SeatingCapacity}
                                                onChange={(e) => this.setState({ SeatingCapacity: e.target.value?.trim(), SeatingCapacityErr: '' })}
                                                onBlur={(e) => e.target.value?.trim() && this.verifyMeetingRoomComboSlot()}
                                            />
                                            {<span className='text-danger text-start text-left d-block mt-1'>{SeatingCapacityErr}</span>}

                                        </div>
                                        <div className="col-xl-3">
                                            <label htmlFor="validationCustom03">
                                                Location<span className="text-red">*</span>
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="validationCustom03"
                                                required=""
                                                value={Location}
                                                onChange={(e) => this.setState({ Location: e.target.value, LocationErr: '' })}
                                                onBlur={(e) => e.target.value?.trim() && this.verifyMeetingRoomComboSlot()}
                                            />
                                            {<span className='text-danger text-start text-left d-block mt-1'>{LocationErr}</span>}
                                        </div>
                                        <div className="col-xl-3">
                                            <label htmlFor="validationCustom03">
                                                From Time<span className="text-red">*</span>
                                            </label>
                                            <TimePicker
                                                className='time-picker'
                                                style={{ background: '#ffff', width: '100%' }}
                                                max={ToTime != '' ? ToTime : null}
                                                value={FromTime != undefined ? FromTime.replace(/\s+(?:AM|PM)/, "") : ''}
                                                onChange={(e) => this.setState({ FromTime: e.target.value, FromTimeErr: '' })}
                                                onInput={() => this.setState({ FromTimeErr: '' })}
                                                step={60 * 15} />
                                            {<span className='text-danger text-start text-left d-block mt-1'>{FromTimeErr}</span>}
                                        </div>
                                        <div className="col-xl-3">
                                            <label htmlFor="validationCustom03">
                                                To Time<span className="text-red">*</span>
                                            </label>
                                            <TimePicker
                                                className='time-picker'
                                                min={FromTime != '' ? FromTime : null}
                                                style={{ width: '100%' }}
                                                value={ToTime != undefined ? ToTime.replace(/\s+(?:AM|PM)/, "") : ''}
                                                onChange={(e) => this.setState({ ToTime: e.target.value, ToTimeErr: '' })}
                                                onInput={() => this.setState({ ToTimeErr: '' })}
                                                step={60 * 15} />
                                            {<span className='text-danger text-start text-left d-block mt-1'>{ToTimeErr}</span>}
                                        </div>

                                        <div className="col-xl-3">
                                            <label htmlFor="validationCustom03">Price(INR)<span className="text-red">*</span></label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="validationCustom03"
                                                required=""
                                                value={RateInINR}
                                                onChange={(e) => this.setState({ RateInINR: e.target.value, RateInINRErr: '' })}
                                            />
                                            {<span className='text-danger text-start text-left d-block mt-1'>{RateInINRErr}</span>}
                                        </div>
                                        <div className="col-xl-3">
                                            <label htmlFor="validationCustom03">Price(USD)<span className="text-red">*</span></label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="validationCustom03"
                                                required=""
                                                value={RateInUSD}
                                                onChange={(e) => this.setState({ RateInUSD: e.target.value, RateInUSDErr: '' })}
                                            />
                                            {<span className='text-danger text-start text-left d-block mt-1'>{RateInUSDErr}</span>}
                                        </div>
                                    </div>
                                </div>

                                {!IsComboSlotAvailable &&
                                    <div className="row m-0">
                                        <div className="table-responsive w-50">

                                            <div className="text-end mt-2">
                                                <button
                                                    type="button"
                                                    className="btn btn-aqua"
                                                    onClick={() => this.handleAddComboSlot()}
                                                >
                                                    Add +
                                                </button>
                                            </div>
                                            <div className="table-responsive ">
                                                <table className="table border text-nowrap text-md-nowrap table-bordered mb-0 mt-1">
                                                    <thead>
                                                        <tr>
                                                            <th className="text-center">Sr No.</th>
                                                            <th className="text-center">Combo Slot Hrs</th>
                                                            <th className="text-center">Price In INR</th>
                                                            <th className="text-center">Price In USD</th>
                                                            <th style={{ width: '60px' }} className="text-center">
                                                                Delete
                                                            </th>
                                                        </tr>
                                                    </thead>

                                                    <tbody>
                                                        {
                                                            this.state.comboSlotList.length > 0
                                                                ? this.state.comboSlotList.map((data, i) => (
                                                                    <tr key={i}>

                                                                        {/* Sr No */}
                                                                        <td className="text-center">
                                                                            {i + 1}
                                                                        </td>

                                                                        {/* Combo Slot Hours */}
                                                                        <td className="text-center">
                                                                            <input
                                                                                type="text"
                                                                                value={data.ComboSlotHours || ''}
                                                                                className="form-control"
                                                                                onChange={(e) =>
                                                                                    this.handleComboSlotChange(
                                                                                        i,
                                                                                        'ComboSlotHours',
                                                                                        e.target.value
                                                                                    )
                                                                                }
                                                                            />
                                                                        </td>

                                                                        {/* INR */}
                                                                        <td className="text-center">
                                                                            <input
                                                                                type="text"
                                                                                value={data.RateInINR || ''}
                                                                                className="form-control"
                                                                                onChange={(e) =>
                                                                                    this.handleComboSlotChange(
                                                                                        i,
                                                                                        'RateInINR',
                                                                                        e.target.value
                                                                                    )
                                                                                }
                                                                            />
                                                                        </td>

                                                                        {/* USD */}
                                                                        <td className="text-center">
                                                                            <input
                                                                                type="text"
                                                                                value={data.RateInUSD || ''}
                                                                                className="form-control"
                                                                                onChange={(e) =>
                                                                                    this.handleComboSlotChange(
                                                                                        i,
                                                                                        'RateInUSD',
                                                                                        e.target.value
                                                                                    )
                                                                                }
                                                                            />
                                                                        </td>

                                                                        {/* Action */}
                                                                        <td className="text-center">
                                                                            <button
                                                                                type="button"
                                                                                className="btn btn-outline btn-sm text-danger"
                                                                                onClick={() =>
                                                                                    this.handleDeleteComboSlot(i)
                                                                                }
                                                                            >
                                                                                <i className="fa fa-trash action_btn_table" />
                                                                            </button>
                                                                        </td>

                                                                    </tr>
                                                                ))
                                                                : (
                                                                    <tr>
                                                                        <td className="text-center" colSpan={20}>
                                                                            No record found
                                                                        </td>
                                                                    </tr>
                                                                )
                                                        }
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                }

                                <div className=" mt-2 save-can d-block">

                                    <div className="text-end">
                                        <button
                                            type="button"
                                            className="btn btn-aqua"
                                            onClick={() => this.handleSave()}
                                        >
                                            {IsUpdate == 1 ? 'Update' : 'Save'}
                                        </button>
                                        <button
                                            type="button"
                                            className="btn btn-gray ms-2"
                                            onClick={() => this.OnCancel()}
                                        >
                                            Back
                                        </button>

                                    </div>
                                </div>


                            </div>
                        </div>
                    </div>
                </>
            </>
        )
    }
}
export default withRouter(connect(null, { getMeetinRoomMasterList_action, insertUpdateMeetinRoomMaster_action, deleteMeetinRoomMaster_action, fill_action, verifyMeetingRoomComboSlot_action })(MeetingRoomMasterAU))